<template>
    <combo-box
        :id="identifier"
        :label="label + ' ' + requiredAsterisk"
        :input-class="{'is-invalid': valid === false}"
        :value="fieldValue"
        @input="updateValue($event)"
        @select-item="$emit('select-item', $event)"
        :options="options"
        :loading="loading"
        :require-selection="requireSelection"
        v-bind="attributes"
        :aria-invalid="!valid"
        :aria-describedby="identifierError"
    >
        <template #prependOption>
            <slot name="prependOption" />
        </template>
        <slot />
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />
    </combo-box>
</template>
<script>
import FormField from "@/mixins/FormField";
import ComboBox from "@/components/ComoboBox";

export default {
    name: 'ComboboxInput',
    components: {ComboBox},
    mixins: [FormField],
    inheritAttrs: false,
    props: {
        options: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        requireSelection: { // wether or not to require a selection item (like a select box)
            type: Boolean,
            required: false,
            default: false,
        }
    }
}
</script>
